import { render, staticRenderFns } from "./cxImg.vue?vue&type=template&id=2ef638b0"
import script from "./cxImg.vue?vue&type=script&lang=js"
export * from "./cxImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports